import {BaseComparisonOperator} from '../base-comparison-operator';
import {EqualOperator} from '../equal-operator/equal-operator';

export class NotEqualOperator extends BaseComparisonOperator {
  compare(value1: unknown, value2: unknown) {
    return !(new EqualOperator().compare(value1, value2));
  }
}
